import axios, { type AxiosResponse } from 'axios';
import { authenticationHeaders } from '../../guided/subcomponents/utils';
import type { ResultResponseDto } from '../../../models/cose-api/response/result-response.dto';
import {makeLogger} from '../../../logger/logger';

const {err} = makeLogger({pathToCurrentFile: 'components/result-page/product-side-panel/product-side-panel.service.ts'});
export default class ProductSidePanelService {
  private apigeeTokenUrl: string;
  private apigeeAuth: string;
  private apiKey: string;
  private endpoint: URL;

  constructor(apigeeTokenUrl: string, apigeeAuth: string, apiKey: string, endpoint: URL) {
      Object.assign(this, {apigeeTokenUrl, apigeeAuth, apiKey, endpoint});
  }

  query<T>(term: string, country: string, language: string, brand: string, target: string, searcher = ''): Promise<AxiosResponse<ResultResponseDto<T>>> {
      const searcherName = searcher || `${target === 'ranges' ? 'products' : 'popular'}/${target}`;
      return this.fetch(this.buildRequestDetails(term, country, language, brand, searcherName));
  }

  async fetch(body) {
      const authHeaders = await authenticationHeaders({
        apikey: this.apiKey,
        tokenUrl: this.apigeeTokenUrl,
        apigeeBasicAuth: this.apigeeAuth,
      });

      const requestHeaders = {
        headers: {
          'content-type': 'application/json',
          ...authHeaders,
        },
      };
      return axios
        .post(
          this.endpoint.toString(),
          body,
          requestHeaders
        )
        .catch((error) => {
            err('Error fetching Side Panel documents:', error);
            return null;
        });
  }

  buildRequestDetails(
    term: string,
    country: string,
    language: string,
    brand: string,
    searcherName: string
  ) {
      const searcher = `${brand}/${searcherName}`;

      return {
        searcher,
        country: country,
        language: language,
        term: term,
        forceTerm: true,
        pagination: {
          limit: 5,
          offset: 0
        }
      };
  }

  static productDocumentsMap<T>(documents: T[], locale: string) {
      return documents.map(doc => {
          return {
            title: doc[locale]['title'],
            openUrl: doc[locale]['openUrl'],
            f3Cat: doc[locale].f3Cat,
            f2Cat: doc[locale].f2Cat,
            f1Cat: doc[locale].f1Cat,
            docType: doc[locale].docType
          };
      });
  }

  static productRangesMap<T>(ranges: T[]) {
      return ranges.map(range => { return {title: range['title'], openUrl: range['openUrl']};});
  }
}
